import React, { PureComponent } from 'react';
import RegistroDatosAdicionales from './RegistroDatosAdicionales';

class RegistroAsientoContable extends PureComponent {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    convertirFecha(fechaISO8601) {
        var fecha = new Date(fechaISO8601);
      
        var dia = fecha.getDate();
        if (dia < 10) {
            dia = "0" + dia;
        }
      
        var mes = fecha.getMonth() + 1;
        if (mes < 10) {
            mes = "0" + mes;
        }
        var anio = fecha.getFullYear();
      
        var fechaFormateada = dia + '/' + mes + '/' + anio;
      
        return fechaFormateada;
      }


      async obtencionDatosAbrirModalAsientosContables(registro) {
        const {cargarInformacionReproceso, obtenerDatosDetalleAsiento, cambiarCheckAsientosContables, seleccionarOpcionCombo } = this.props;

        // reseteo el combo de accion masiva al abrir el modal de detalle
        await cambiarCheckAsientosContables("checkTodosAsientosContables", false)
        await seleccionarOpcionCombo("comboAccionMasiva", 0, false); 

        let aperturaSucursal = registro.AperturaSucursal == "Sin Apertura" ? null : registro.AperturaSucursal; 
        let aperturaSocio = registro.AperturaCuentaTarjeta == "No" ? null : registro.AperturaCuentaTarjeta; 
    
        if (registro.FechaReproceso) {
            await cargarInformacionReproceso(
                registro.FechaContabilizacion, 
                registro.FechaValorContable, 
                registro.ModeloCabeceraId, 
                aperturaSucursal, 
                aperturaSocio
            );
        }
    
        await obtenerDatosDetalleAsiento(registro);
    }
    
    
    render() {
        const {
            registro,
            registroDesplegado,
            esPar,
            estadosAsientos
        } = this.props;

        //ACTIONS
        const {
            desplegarDatosAdicionales,
            cambiarCheckRegistroResultadoBusqueda
        } = this.props;

        let estaDesplegado = registroDesplegado == registro.AsientocabeceraId;
        
        let estiloPar = esPar ? " seccionGrilla__registro--registroGris" : "";
        let estiloFlechaDesplegado = estaDesplegado ? "seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : "seccionRenglonesModelo__renglonModelo__trianguloDown"
        let estaDesbalanceado = registro.TotalImputadoDebito != registro.TotalImputadoCredito;
        let estaDesbalanceadoDolar = registro.TotalImputadoDebitoDolar != registro.TotalImputadoCreditoDolar;
        let descripcionDesbalance = "Desbalanceo: $" + Math.abs(((parseFloat(registro.TotalImputadoDebito) - parseFloat(registro.TotalImputadoCredito)))).toString();
        let descripcionDesbalanceDolar = "Desbalanceo: U$S" + Math.abs(((parseFloat(registro.TotalImputadoDebitoDolar) - parseFloat(registro.TotalImputadoCreditoDolar)))).toString();
        let estiloDesbalance = estaDesbalanceado | estaDesbalanceadoDolar ? " AsientosContables__registro--registroDesbalance" : "";
        let estadoColor = "";
        let estadoDescripcion = "";
        let iconoMarca = "";
        let nombreCheckbox = "checkboxAsiento" + registro.AsientocabeceraId;
        let estado = estadosAsientos.find(item => item.Id === registro.EstadoId);
        let fechaValorFormateado = this.convertirFecha(registro.FechaValorContable);
        let fechaContabilizacionFormateada = this.convertirFecha(registro.FechaContabilizacion)

        if (estado) {
            estadoColor = " AsientosContables__SeccionGrillaEstado--" + estado.Descripcion.substring(0, 4);
          }

          switch(registro.EstadoId) {
            case 1:
                estadoDescripcion = "Pend. Confirmación"
                break;
            case 2:
                estadoDescripcion = "Confirmado";
                break;
            case 3:
                estadoDescripcion = "Baja";
                break;
            case 4:
                estadoDescripcion = "Enviado al Core";
                break;
        }
        switch (registro.AdministradoraId) {
            case 1:
                iconoMarca = <div className={"seccionDatosGenerales__marcaVisa_sinAbsoluteTemporal AsientosContables__seccionGrillaContenedorMarca--margin"}></div>
                break;
            case 2:
                iconoMarca = <div className={"seccionDatosGenerales__marcaCabal_sinAbsoluteTemporal AsientosContables__seccionGrillaContenedorMarca--margin"}></div>
                break;
            case 3:
                iconoMarca = <div className={"seccionDatosGenerales__marcaMastercard_sinAbsoluteTemporal AsientosContables__seccionGrillaContenedorMarca--margin"}></div>
                break;
        
            default:
                break;
        }

        return (
            <div>
                <div className={"AsientosContables__SeccionGrillaRegistro" + estiloPar + estiloDesbalance}>
                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorCheckbox">
                        <div className="Tarjetas-contenedorCheckboxActivo default-checkbox Tarjetas-default-checkbox">
                            <input id={nombreCheckbox} disabled={!registro.EstaHabilitado} type="checkbox" checked={registro.EstaTildado} onChange={() => cambiarCheckRegistroResultadoBusqueda(!registro.EstaTildado, registro)} />
                            <label className={"label-primary Tarjetas-checkboxLabel" + (registro.EstaTildado ? " Tarjetas-checkboxLabel--checked" : "")} htmlFor={nombreCheckbox}></label>
                        </div>
                    </div>

                    <div onClick={() => this.obtencionDatosAbrirModalAsientosContables(registro)}>
                        <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros seccionRenglonesModelo__contenedorNRenglon AsientosContables__seccionGrillaContenedorFechaValor">
                            {fechaValorFormateado}
                        </div>

                        <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorFechaContabilizacion AsientosContables__seccionGrillaContenedorRegistroFechaCreditoDebito">
                            <div>
                                {fechaContabilizacionFormateada}

                                {registro.FechaReproceso ? 
                                    <div data-toggle="tooltip" data-title="Re-Contabilizado" data-placement="top" data-original-title="" className="AsientosContables__seccionGrillaContenedorFechaContabilizacion--recontabilizacion AsientosContables--floatRight"></div>
                                :
                                    null
                                }
                            </div>
                        </div>

                        <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorModelo">
                            {registro.ModeloCabeceraId}
                        </div>

                        <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorMarca">
                            {iconoMarca}
                        </div>

                        <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorMoneda">
                            {registro.MonedaDescripcion}
                        </div>

                        <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorTotalDebito AsientosContables__seccionGrillaContenedorRegistroFechaCreditoDebito" + (registro.totalDebitoDolares ? " AsientosContables__seccionGrillaContenedorRegistroFechaCreditoDebito--conDolares" : "")}>
                            {estaDesbalanceado ?
                                <div data-toggle="tooltip" data-title={descripcionDesbalance} data-placement="top" data-original-title="">
                                    ${registro.TotalImputadoDebito}
                                </div>
                            :
                                registro.TotalImputadoDebito ?
                                <div>
                                    ${registro.TotalImputadoDebito}
                                </div>
                                :
                                null
                            }

                            {estaDesbalanceadoDolar ?
                                <div data-toggle="tooltip" data-title={descripcionDesbalanceDolar} data-placement="top" data-original-title="">
                                    U$S{registro.TotalImputadoDebitoDolar}
                                </div>
                                :    
                                registro.TotalImputadoDebitoDolar ?
                                    <div className="AsientosContables__CreditoDebitoDolares">
                                        U$S{registro.TotalImputadoDebitoDolar}
                                    </div>
                                    :
                                    null
                            }
                        </div>

                        <div className={"seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorTotalCredito AsientosContables__seccionGrillaContenedorRegistroFechaCreditoDebito" + (registro.totalCreditoDolares ? " AsientosContables__seccionGrillaContenedorRegistroFechaCreditoDebito--conDolares" : "")}>
                            {estaDesbalanceado ?
                                <div data-toggle="tooltip" data-title={descripcionDesbalance} data-placement="top" data-original-title="">
                                    ${registro.TotalImputadoCredito}
                                </div>
                            :
                                registro.TotalImputadoCredito ?
                                    <div>
                                        ${registro.TotalImputadoCredito}
                                    </div>
                                    :
                                    null
                            }

                            {estaDesbalanceadoDolar ?
                                <div data-toggle="tooltip" data-title={descripcionDesbalanceDolar} data-placement="top" data-original-title="">
                                    U$S{registro.TotalImputadoCreditoDolar}
                                </div>
                                :
                                registro.TotalImputadoCreditoDolar ?
                                    <div className="AsientosContables__CreditoDebitoDolares">
                                        U$S{registro.TotalImputadoCreditoDolar}
                                    </div>
                                :
                                    null
                            }   
                        </div>

                        <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorEstado">
                            <div className={"AsientosContables__SeccionGrillaEstado" + estadoColor}>
                                {estadoDescripcion}
                            </div>
                        </div>
                    </div>
                    
                    <div className="seccionRenglonesModelo__renglonModelo__contenedorRegistros AsientosContables__seccionGrillaContenedorFlechaDesplegable" onClick={() => desplegarDatosAdicionales(registro.AsientocabeceraId)}>
                        <div className={estiloFlechaDesplegado}></div>
                    </div>
                </div>

                
                <RegistroDatosAdicionales 
                    registro={registro}
                    estaDesplegado={estaDesplegado}
                />
            </div>
        );
    }
}

export default RegistroAsientoContable;